import Color from "color";

const swatch = {
    primary: {
        lighter: "#f5f2ed",
        light: "#e1dad0",
        base: "#c4b5a2",
        dark: "#8f7759",
    },
    secondary: {
        light: "#3a3a3c",
        base: "#3a3a3c",
        dark: "#3a3a3c",
    },
    quinary: {
        light: "#0b88e0",
        base: "#20618f",
        dark: "#164566",
    },
    white: "#ffffff",
    black: "#000000",
    grey: {
        lighter: "#f7f6f5",
        light: "#e5e2e0",
        base: "#a8a6a3",
        dark: "#72706e",
        darker: "#43403d",
        darkest: "#3a3a3c",
    },
    success: {
        base: "#028526",
        light: "#D1EEDD",
    },
    error: "#df1642",
    warning: "#ffbb38",
    outline: "#09f",
};

export default {
    primary: {
        main: swatch.primary.base,
        contrast: swatch.secondary.base,
        lighter: swatch.primary.lighter,
        light: swatch.primary.light,
        dark: swatch.primary.dark,
    },
    secondary: {
        main: swatch.secondary.base,
        contrast: swatch.white,
        light: swatch.secondary.light,
        dark: swatch.secondary.dark,
    },
    quarternary: {
        // Custom
        main: swatch.black,
        light: swatch.secondary.dark,
        contrast: swatch.white,
    },
    quinary: {
        // Custom
        main: swatch.quinary.base,
        light: swatch.quinary.light,
        contrast: swatch.white,
    },
    common: {
        background: swatch.white,
        backgroundContrast: swatch.grey.dark,
        accent: swatch.grey.lighter,
        accentContrast: swatch.grey.dark,
        border: swatch.grey.light,
        disabled: swatch.grey.base,
        // Custom
        disabledLighter: swatch.grey.lighter,
        disabledLight: swatch.grey.light,
        disabledDark: swatch.grey.dark,
        borderDark: swatch.grey.dark,
        borderDarker: swatch.grey.darker,
        backgroundHover: swatch.grey.light,
        outline: swatch.outline,
    },
    text: {
        main: swatch.black,
        disabled: swatch.grey.base,
        accent: swatch.grey.darker,
        link: swatch.primary.dark,
        // Custom
        linkHover: swatch.secondary,
    },
    success: {
        main: swatch.success.base,
        contrast: swatch.white,
        light: swatch.success.light,
    },
    danger: {
        main: swatch.error,
        contrast: swatch.white,
    },
    warning: {
        main: swatch.warning,
        contrast: swatch.white,
    },
    info: {
        main: swatch.grey.base,
        contrast: swatch.grey.dark,
    },
    // Custom
    pagination: {
        main: swatch.grey.light,
        hover: Color(swatch.grey.light).darken(0.15).hex(),
    },
    footer: {
        main: swatch.grey.darkest,
        contrastMain: swatch.white,
        bottom: swatch.grey.light,
    },
    header: {
        main: swatch.grey.darkest,
        contrastMain: swatch.white,
        cartButtonBackground: swatch.primary.base,
        mainNavBackground: swatch.grey.dark,
        mainNavBorder: swatch.grey.dark,
        mainNavText: swatch.white,
        drawerAccent: swatch.secondary.base,
        top: `linear-gradient(to right, ${swatch.grey.darkest} 50%, ${swatch.grey.darkest} 50%)`,
        topContrast: swatch.white,
    },
};
